import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { EmailService } from 'src/app/services/email-service';

@Component({
    selector: 'app-mail',
    templateUrl: './mail.component.html',
    styleUrls: ['./mail.component.scss'],
    standalone: false
})
export class WidgetMailComponent implements OnInit {
  static key = 100809;
  
  selectedMail: any = null;
  isNewMailOpen: boolean = false;
  public emails: any[] = [];
  heading: any;
  searchText: string = '';
  isLoggedIn = false;
  @Input() pageType: string = 'fullscreen';
  @Input("item") item: any;
  @Input("pageKey") pageKey: any;
  @Output("onSizeChange") onSizeChange = new EventEmitter<any>();

  @ViewChild("mailCharDiv", { static: true }) mailCharDiv!: ElementRef;

  constructor(public emailService: EmailService) { }

  ngOnInit() {
    this.loadLoginAndFetchEmails();
  }
  
loadLoginAndFetchEmails(): void {
  this.emailService.login().subscribe({
    next: async (result) => {
      if (result === 'success') {
        this.isLoggedIn = true;
        console.log('User successfully logged in');

        try {
          const emails = await this.emailService.getEmails();
          if (emails && emails.length > 0) {
            this.selectedMail = emails[0];
            this.emails = emails;   // ✅ set to UI list
          } else {
            console.warn('No emails found.');
          }
        } catch (error) {
          console.error('Error fetching emails after login:', error);
        }

      } else {
        this.isLoggedIn = false;
        console.log('Login failed');
      }
    },
    error: (err) => {
      this.isLoggedIn = false;
      console.error('Login error:', err);
    }
  });
}



  // Method to handle mail selection
  onMailSelected(mailId: string): void {
    // Reset the selected mail before fetching the new one
    this.selectedMail = null;
    this.isNewMailOpen = false;
  
    // Fetch the selected mail details
    this.emailService.getEmailById(mailId).then((mail) => {
      // console.log('Mail fetched from service:', mail); 
      this.selectedMail = mail;
      // console.log('Selected Mail:', this.selectedMail); 
    }).catch((error) => {
      console.error('Error fetching mail details:', error);
    });
  }

  openNewMail(){
    this.isNewMailOpen = true;
    this.selectedMail = null; 
    console.log('New mail opened:', this.isNewMailOpen);
  }
      
}